import { Id, Wishlist, WishlistItem } from "@/data/types";
import { RootState } from "../store";

export function selectDefaultWishlistId(state: RootState): Id | undefined {
  const myWishlist = state.wishlists.wishlists.filter(
    (w) => w.userId === state.user.user?.id,
  )[0];

  return myWishlist?.id;
}

export const selectWishlist =
(wishlistId?: Id) =>
  (state: RootState): Wishlist | undefined => {
    if (!wishlistId) {
      return undefined;
    }

    const wishlist = state.wishlists.wishlists.find((w) => w.id === wishlistId);
    if (typeof wishlist == "undefined") {
      return undefined;
    }
    const items = [...wishlist.items];
    items.reverse();

    return {
      ...wishlist,
      items,
    }
  };

export const selectIsLoadingWishlist = (state: RootState): boolean => state.wishlists.isLoading;

export const selectMultipleWishlists =
(ids: Id[]) =>
  (state: RootState): Wishlist[] | undefined => {
    if (!ids) {
      return undefined;
    }

    return state.wishlists.wishlists.filter((w) => ids.indexOf(w.id) !== -1);
  };

export const selectWish =
(wishlistId: Id | undefined, wishId: Id | undefined) =>
  (state: RootState): WishlistItem | undefined => {
    if (!wishId || !wishlistId) {
      return undefined;
    }
    const wishlist = state.wishlists.wishlists.find((w) => w.id === wishlistId);
    if (!wishlist) {
      return undefined;
    }
    return wishlist.items.find((wish) => wish.id === wishId);
  };
